import RecordRTC from "@/utils/RecordRTC.js";

export default {  
  data: () => ({
    audio: {},
    recorder: null,
    audioUrl: null,
    audioBlob: null,
    timeOut: null,
    recording: false
  }),  
  computed: {    
    audio_recognize() {
      return this.$store.getters.audio_recognize;
    }
  },
  methods: {
    captureMicrophone(callback) {
      navigator.mediaDevices
        .getUserMedia({
          audio: true
        })
        .then(function(microphone) {
          callback(microphone);
        })
        .catch(function(error) {
          alert(
            "Ошибка. Не включается микрофон."
          );
          console.error(error);
        });
    },
    startRec() {
      this.not_recognized = null;            
      let that = this;
      this.captureMicrophone(function(microphone) {
        that.audio.srcObject = microphone;

        that.recorder = RecordRTC(microphone, {
          type: "audio",
          recorderType: RecordRTC.StereoAudioRecorder,
          audioBitsPerSecond: 32000,
          numberOfAudioChannels: 1,
          desiredSampRate: 16000
        });
        that.recording = true;
        that.recorder.startRecording();
        that.recorder.microphone = microphone;
      });

      this.timeOut = setTimeout(() => {
        alert(
          "Время записи 30 секунд превышено. Запись автоматически остановлена."
        );
        this.stopRec();
      }, 30000);
    },
    stopRec() {      
      clearTimeout(this.timeOut);
      this.recording = false;
      this.recorder.stopRecording(this.stopRecordingCallback);
    },
    stopRecordingCallback() {
      this.audio.srcObject = null;
      this.audioBlob = this.recorder.getBlob();
      this.audioUrl = URL.createObjectURL(this.audioBlob);
      this.recorder.microphone.stop();
    },
    playRec() {
      const audio = new Audio(this.audioUrl);
      audio.play();
    },
    sendRec() {       
      let idUser = this.user.id;
      let idSatz = this.satz.id;
      if (idUser!=null && idSatz!=null && this.audioBlob!=null) {
        const formData = new FormData();
        formData.append("idUser", idUser);
        formData.append("idSatz", idSatz);
        formData.append("audio", this.audioBlob);        
        this.$store.dispatch("getCourseModeRegimeAudioRecognize", {
          formData: formData
        });
      }
    }
  }
};
